// extracted by mini-css-extract-plugin
module.exports = {"card_search":"SearchDiscover_card_search__2i_eU","pagination":"SearchDiscover_pagination__2ydwt"};